import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { theme } from '../../../../core/design-system/theme'
import { useBookingContext, BookingStepShell } from '../BookingFlowView'

const labelStyle = {
  fontSize: 11,
  fontWeight: 600,
  color: theme.colors.textSecondary,
  display: 'block',
  marginBottom: 5,
  fontFamily: 'var(--font-body)',
  letterSpacing: '0.04em',
}

const baseInputStyle = {
  background: theme.colors.card,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: theme.layout.inputRadius,
  padding: 12,
  fontSize: 15,
  color: theme.colors.textPrimary,
  fontFamily: 'var(--font-body)',
  width: '100%',
  boxSizing: 'border-box',
  outline: 'none',
}

function isValidEmail(val) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)
}

export default function BookingStep1View() {
  const { viewModel } = useBookingContext()
  const navigate = useNavigate()

  const initial = viewModel.draft.parentInfo ?? {}
  const [fullName, setFullName] = useState(initial.fullName ?? '')
  const [email, setEmail] = useState(initial.email ?? '')
  const [phone, setPhone] = useState(initial.phone ?? '')
  const [focusedField, setFocused] = useState(null)

  const canContinue = fullName.trim().length > 0 && isValidEmail(email)

  function handleContinue() {
    if (!canContinue) return
    viewModel.setParentInfo({
      fullName: fullName.trim(),
      email: email.trim(),
      phone: phone.trim(),
    })
    navigate('/book/children')
  }

  function inputStyle(field) {
    return {
      ...baseInputStyle,
      outline: focusedField === field ? `2px solid ${theme.colors.terracotta}` : 'none',
    }
  }

  return (
    <BookingStepShell
      step={1}
      title="Tell us about yourself"
      onBack={() => navigate(-1)}
      onContinue={handleContinue}
      continueDisabled={!canContinue}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div>
          <label htmlFor="fullName" style={labelStyle}>
            FULL NAME
          </label>
          <input
            id="fullName"
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Jane Smith"
            autoComplete="name"
            style={inputStyle('fullName')}
            onFocus={() => setFocused('fullName')}
            onBlur={() => setFocused(null)}
          />
        </div>

        <div>
          <label htmlFor="email" style={labelStyle}>
            EMAIL
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="jane@example.com"
            autoComplete="email"
            style={inputStyle('email')}
            onFocus={() => setFocused('email')}
            onBlur={() => setFocused(null)}
          />
        </div>

        <div>
          <label htmlFor="phone" style={labelStyle}>
            PHONE (OPTIONAL)
          </label>
          <input
            id="phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+1 555 000 0000"
            autoComplete="tel"
            style={inputStyle('phone')}
            onFocus={() => setFocused('phone')}
            onBlur={() => setFocused(null)}
          />
        </div>
      </div>
    </BookingStepShell>
  )
}
